export const homeCarousel = [
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/pembinaAgenBrilink.webp`,
    title: `Pembina Agen BRILink`,
    message: `Jangkau calon Agen BRILink potensial dengan sales management yang akurat dari BRIBRAIN`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/mantrilogo.webp`,
    title: `Mantri`,
    message: `Wujudkan target identifikasi hingga pemasaran terpadu dengan saran produk dan nasabah yang akurat`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/kantor1.webp`,
    title: `Kantor Pusat`,
    message: `Pantau produktivitas tenaga pemasar di tiap Unit Kerja BRI terkait nasabah kelolaan dengan BRIBRAIN`,
  },
];
